// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Protocol type — enum, not string. 1 byte.
 */
export enum ProtocolType {
  Unknown = 0,
  Modbus = 1,
  Ln1 = 2,
  Mce = 3,
  Opc = 4,
  Cga = 5,
  LobbyVision = 6,
  Sequent = 7,
  Numato = 8,
  Stm32 = 9,
  Rvu = 10,
  Diligent = 11,
  Nyct = 12,
  BacNet = 13,
}
